<template>
  <el-dialog :visible="show" append-to-body :title="row ? '修改村级' : '新增村级'" width="500px" @close="closeDialog">
    <el-form label-width="120px" ref="vForm" :model="vForm">
      <el-form-item label="排序值" prop="sort" :rules="{ required: true, message: '排序值必填' }">
        <el-input v-model="vForm.sort"></el-input>
      </el-form-item>
      <el-form-item label="村级名称" prop="name" :rules="{ required: true, message: '区域名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>
      <el-form-item label="小程序展示风格" prop="ext.spread" :rules="{ required: true, message: '展示风格必填' }">
        <el-select v-model="vForm.ext.spread" filterable placeholder="请选择" style="width: 100%">
          <el-option label="一图" :value="6"></el-option>
          <el-option label="二图" :value="7"></el-option>
          <el-option label="三图" :value="1"></el-option>
          <el-option label="四图" :value="2"></el-option>
          <el-option label="一+三" :value="3"></el-option>
          <el-option label="五图" :value="4"></el-option>
          <el-option label="六图" :value="5"></el-option>
        </el-select>
        <div v-if="vForm.spread == 3" class="v-form-tips">此布局第一张推荐图为横图，建议VR作品上传690x200px封面</div>
        <div v-if="vForm.spread == 6" class="v-form-tips">一图风格建议VR作品上传690x200px封面</div>
        <div v-if="vForm.spread == 7" class="v-form-tips">二图风格建议VR作品上传335x200px封面</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    pid: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      doSubmitLoading: false,
      vForm: {
        id: '',
        name: '',
        sort: 0,
        pid: this.pid,
        level: 3,
        ext: {
          spread: '',
        },
      },
    };
  },

  created() {
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    //提交表单
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.regionAdmin[this.row ? 'edit' : 'add'](this.vForm);
        this.$message.success(!this.row ? '添加成功' : '修改成功');
        this.$emit('success');
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>
